// src/app/utils/initializeCampaign.ts
import dayjs from "dayjs";
import { Campaign } from "../models/campaign";

export const initializeNewCampaign = (): Campaign => {
  return {
    id: "",
    title: "",
    startDate: dayjs(),
    endDate: dayjs(),
    isActive: true,
    gameType: 1,
    collectUserData: 1,
    companyName: "",
    venue: "",
    description: "",
    listOrder: 0,
    customCSS: "",
    modalText: "",
    modalPassText: "",
    modalBg: "",
    modalInnerBg: "",
    modalColor: "#fff",
    modalTextColor: "#545454",
    modalBorderRadius: true,
    hasStartScreen: false,
    startVideo: "",
    screenStyle: {
      id: "",
      gameFromTop: 0,
      pageTitle: "",
      titleFromTop: 60,
      titleWidth: 48,
      titleFontSize: 60,
      motto: "",
      logo: "",
      logoFromTop: 170,
      logoHeight: 120,
      screenBg: "",
      screenCenterBg: "",
      screenCenterBgFromTop: 1300,
      screenColor: '#fff',
      textColor: '#000',
      fontSize: 4,
      fontFamily: "Roboto",
      scoreboardButton: true,
      scoreboardButtonImage: "",
      startScreenButtonImage: "",
      screenType: 1,
      campaignId: ""
    },
    wheel: {
      id: "",
      wheelDiameter: 900,
      colorFirst: '#fff',
      colorSecond: '#000',
      circleImage: "",
      wheelTextColor: "red",
      wheelTextColor2: "blue",
      wheelBorderColor: "#e60f0f",
      wheelPinColor: "#eeeeee",
      wheelPinImage: "",
      radiusLine: false,
      radiusLineColor: "#e60f0f",
      spinnerDecoration: true,
      spinnerImage: "",
      spinnerCover: "",
      spinnerCoverOpacity: false,
      spinnerRotate: 108.5,
      spinnerEffect: true,
      clockwise: true,
      spinDuration: 7,
      spinSpeed: 1,
      sliceAmount: 6,
      stockControlRate: null,
      probabilityDropRate: null,
      showPrizeValues: true,
      spinningMethod: 1,
      spinButtonImage: "",
      slices: Array(6).fill({
        id: "",
        prizeValue: "",
        prizeImage: "",
        wedgeImage: "",
        isPrize: true,
        probability: null,
        stock: null,
        initialStock: null,
        onStockControl: false,
        stockDropped: false,
        listOrder: null,
      }),
      campaignId: ""
    },
    puzzle: {
      id: "",
      puzzleDiameter: 900,
      puzzleImage: "",
      puzzleDuration: 3,
      hasCounter: false,
      tileAmount: 4,
      campaignId: ""
    },
    scratchWin: {
      id: "",
      coverImage: "",
      stockControlRate: null,
      probabilityDropRate: null,
      campaignId: ""
    },
    touchWin: {
      id: "",
      slotImage: "",
      objectImage: "",
      gameDuration: 90,
      pointPerTouch: 10,
      tileAmount: 3,
      campaignId: ""
    },
    matchWin: {
      id: "",
      coverImage: "",
      coverColor: "#eeeeee",
      matchWinType: 1,
      gameDuration: undefined,
      moves: 20,
      pointMultiplier: 10,
      tileAmount: 3,
      matchObjectAmount: 6,
      cardBorderRadius: false,
      disappearOnMatch: false,
      matchObjects: Array(6).fill({
        id: "",
        objectValue: "",
        objectImage: "",
      }),
      campaignId: ""
    },
    quiz: {
      id: "",
      text: "",
      quizType: 1,
      gameDuration: undefined,
      moves: undefined,
      continueOnWrong: false,
      columnType: 1,
      questionAmount: 5,
      hasCategory: false,
      campaignId: ""
    },
    catchGame: {
      id: "",
      gameHeight: 900,
      gameDuration: 60,
      pointMultiplier: 10,
      minSpawnGap: 450,
      catchObject: "",
      catcher: "",
      floor: "",
      floorHeight: 80,
      sliderColor: '#fff',
      campaignId: ""
    },
    formState: {
      id: "",
      formEmail: true,
      formPhone: true,
      formCompany: false,
      formGender: true,
      formContract: "",
      formAddPermission: "",
      formAddPermission2: "",
      formAddPermissionTitle: "",
      formAddPermission2Title: "",
      bonusField: "",
      campaignId: "",
      duplicateCheck: false
    },
  };
};

export const initializeCampaignData = (campaignData: Campaign): Campaign => {
  return {
    ...campaignData,
    startDate: dayjs(campaignData.startDate),
    endDate: dayjs(campaignData.endDate),
  };
};
